import React, { useEffect, useState } from 'react'
import './AdminSidebar.css'
import Logo from '../../../../assets/admin-svgrepo-com.svg';
import NavIcon from '../../../../assets/nav-icon.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import close from "../../../../assets/close-icon.svg"
import { Link, withRouter } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
import { sideMenuItems } from '../../../../Util/helper'
import { config } from '../../../../config';
import axiosApi from '../../../../core/interceptor/interceptor'
import SimpleBarReact from "simplebar-react";
import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setPermission } from '../../../../Store/reducers/PermissionsReducer';
import { contactUsCount, setContactUsCount } from '../../../../Store/reducers/ContactUsReducer';
import LocationModal from '../AdminLeagues/Overview/League/modals/LocationModal/LocationModal';
import Popup from 'reactjs-popup';


function AdminSidebar(props) {

	const [state, setState] = useState({
		selectNav: 'menu',
		selectToggle: 'menu',
	});
	const [open, setOpen] = useState(false);

	const history = useHistory();
	const [myPermissions, setMyPermissions] = useState([]);
	const [showSidebar, setShowSidebar] = useState(false);
	const contactCount = useSelector(contactUsCount);
	const dispatch = useDispatch();
	useEffect(() => {
		getMyPermissions();
		let intervalId;
		if (localStorage.token) {
			intervalId = setInterval(() => {
				getContactUsCount();
			}, 15000);
		}
		return (() => {
			clearInterval(intervalId);
		})
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		dispatch(setPermission(myPermissions));
		//eslint-disable-next-line
	}, [myPermissions]);

	useEffect(() => {
		if (props && props.location && props.location.pathname) {
			const urlArr = props.location.pathname.split('/');
			if (urlArr && urlArr.length > 1) {
				setState((prev) => ({
					...prev,
					selectNav: urlArr[1] === 'admin' ? (urlArr && urlArr[2] ? urlArr[2] : 'menu') : urlArr[1],
				}))
			}
		}
	}, [props?.location?.pathname, props]);

	const getMyPermissions = () => {
		axiosApi.get(`${config.apiUrl}/permissions`)
			.then((response) => {
				if (response && response.data && response.data.data && response.data.data.length) {
					const slug = response.data.data.map(x => x.acl_permission && x.acl_permission.slug);
					setMyPermissions(slug);
				}
			});
	}

	const selectedSidebar = (nav, selectChildToggle = null) => {
		setState((prevState) => {
			return ({
				...prevState,
				'selectNav': nav,
				'selectToggle': state.selectToggle === nav && !selectChildToggle ? null : nav,
				'selectChildToggle': selectChildToggle || state.selectChildToggle,
			})
		});
	}

	const handleModalCloseResponse = (resp) => {

		setOpen(false);
	}

	const getContactUsCount = () => {
		axiosApi.get(`${config.apiUrl}/contact-us/count`)
			.then((res) => {
				dispatch(setContactUsCount(res.data.data.count));
			}, (err) => {
				console.error(err);
			})
	}

	const toggle = (toggleNav) => {
		selectedSidebar(toggleNav);
	}

	const logout = () => {
		localStorage.clear();
		history.push('/login');
	}


	return (
		<>
			<div className='header-blk'>
				<img className='adminLogo' src={Logo} alt='logo' />
				{/* <div className={`nav-icon ${showSidebar ? ' active' : ''}`} onClick={() => setShowSidebar(o => !o)}>
					<span></span>
				</div> */}
				{/* <img className={`nav-icon ${showSidebar ? ' active' : ''}`} src={NavIcon} onClick={() => setShowSidebar(o => !o)} alt='nav-icon' /> */}
			</div>
			<div className={`nav-icon ${showSidebar ? ' active' : ''}`} onClick={() => setShowSidebar(o => !o)}>
				<span></span>
			</div>
			<div className={`adminPageSidebar${showSidebar ? ' active' : ''}`}>
				<div className='adminSidebarHeaderContainer'>
					<img className='adminLogo' src={Logo} alt='logo' />
					<img className='close-icon' src={close} onClick={() => setShowSidebar(o => !o)} alt='close-icon' />
				</div>
				<div className="adminPageSidebar-inner">
					<SimpleBarReact className={'sidebarInner-container'}>
						{
							sideMenuItems.map((x, i) => x.childs && x.childs.length && myPermissions.indexOf(x.slug) > -1 ? (
								<Fragment key={`unique-key-sidebar-parent-${i}`}>
									<Link to={!x.childs && (state.selectNav !== x.route ? `${props.match.url}/${x.route}` : `${props.match.url}/${state.selectNav}`)} onClick={() => toggle(x.route)}>
										<div className={`adminSidebarOption${state.selectToggle === x.route ? ' active' : ''} ${state.selectNav === x.route ? ' adminSidebarOptionSelected' : ''}`}>
											<FontAwesomeIcon icon={x.icon} className='adminSidebarFontAwesome' />
											<div className="sidebar-item">
												<p className='adminSidebarOptionText'>{x.text}</p>
											</div>
											<span className='adminSidebarArrow'></span>
										</div>
									</Link>
									<ul className={`dropdown-menu ${state.selectToggle === x.route ? 'active' : ''}`}>
										{
											x.childs.map((y, _i) =>
												<Fragment key={`unique-key-sidebar-child-${_i}`}>
													{
														y.type === 'location' ? <li className={state.selectChildToggle === (y.url ? y.url : x.route) ? 'active' : ''} onClick={() => setOpen(true)}><a>{y.text}</a></li>
															:
															y.type === 'event-page' || y.type === 'bulk-messages' && myPermissions.indexOf(y.acl) > -1 ? <li className={state.selectChildToggle === (y.url ? y.url : x.route) ? 'active' : ''}>
																<Link to={`${props.match.url}${x.route ? '/' + 'events' : ''}${y.url ? '/' + y.url : ''}`} onClick={() => selectedSidebar(x.route, (y.url ? y.url : x.route))}>{y.text}</Link>
															</li>
																:
																y.type !== 'event-page' && y.type !== 'bulk-messages' && <li className={state.selectChildToggle === (y.url ? y.url : x.route) ? 'active' : ''}>
																	<Link to={`${props.match.url}${x.route ? '/' + x.route : ''}${y.url ? '/' + y.url : ''}`} onClick={() => selectedSidebar(x.route, (y.url ? y.url : x.route))}>{y.text}</Link>
																</li>
													}
												</Fragment>
											)
										}
									</ul>
								</Fragment>
							) : (myPermissions.indexOf(x.slug) > -1 || x.visible) ? <Link to={`${props.match.url}/${x.route}`} onClick={() => selectedSidebar(x.route)} key={`admin-sidebar-option-${i}`}>
								<div className={`adminSidebarOption${state.selectNav === x.route ? ' adminSidebarOptionSelected' : ''}`}>
									<FontAwesomeIcon icon={x.icon} className='adminSidebarFontAwesome' />
									{/* && contactCount > 0 */}
									<div className="sidebar-item"><p className='adminSidebarOptionText'>{x.text}</p>{x.slug === 'contact_us' && contactCount > 0 ? <span className="contact-us-count"> {contactCount}</span> : ''}</div>
									{/* <a className='adminSidebarArrow' /> */}
								</div>
							</Link> : ''
							)
						}
					</SimpleBarReact>
				</div>
				<div className="signout-btn">
					<button className='adminSidebarLogoutButton' onClick={() => logout()}>Sign Out</button>
				</div>
				<Popup closeOnDocumentClick={false} open={open}>
					<LocationModal type={'Modify'} closeModal={handleModalCloseResponse} />
				</Popup>
			</div>
			<div className="sidebar-overlay" onClick={() => setShowSidebar(o => !o)}></div>
		</>
	)
}

export default withRouter(AdminSidebar);